<template>
    <v-flex class="my-5">
        <v-card outlined>
            <v-card-text>
                <v-row align="center">
                    <v-col align="center" cols="12">
                        <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                        <v-img v-if="item.image != null"
                            width="60px"
                            contain :src="item.image"
                        ></v-img>
                    </v-col>
                    <v-col>
                        <div class="body montserrat-bold text-center"
                            style="color: #663e7a;"
                            @focusout="onEditableChange('text')"
                            :contenteditable="editableContent"
                            @paste="filterPastedContent"
                            v-html="item.text"
                        >

                        </div>
                    </v-col>
                </v-row>
                <div class="body montserrat text-center mt-3"
                    @focusout="onEditableChange('subtitle')"
                            :contenteditable="editableContent"
                            @paste="filterPastedContent"
                    v-html="item.subtitle"
                >
                </div>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>

export default {
    props: ["item", "styles", "indexes"],
    methods: {
        onEditableChange (type) {
            this.columnEditableData("imagecard2", this.indexes, type)
        },

        uploadImage () {
            this.$emit("uploadImage", true)
        }
    }
}
</script>
